import { EconomicAnalysis } from '../economic-analysis';

export class EditEconomicsAnalysisModalPayload {
  economicAnalysis: EconomicAnalysis;
}
